import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "../Reveal";
import SectionHeading from "../SectionHeading";
import ArticleCard from "../ArticleCard";
import { ARTICLES } from "../../data/content";

export default function InsightsFeatured() {
  const featured = ARTICLES.find((a) => a.featured) || ARTICLES[0];
  const supporting = ARTICLES.filter((a) => a.slug !== featured.slug).slice(0, 3);

  return (
    <section className="ad-section bg-[#F7F8FA]" data-testid="insights-featured">
      <div className="ad-container">
        <div className="flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-end">
          <SectionHeading
            eyebrow="Insights"
            title={<>Ideas shaping the future of <span className="text-gradient">data and AI.</span></>}
          />
          <Link to="/insights" className="group inline-flex flex-shrink-0 items-center gap-1.5 text-sm font-semibold text-[#1677FF] hover:text-[#00C7D9]">
            Explore All Insights <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </div>

        <div className="mt-12">
          <Reveal>
            <ArticleCard article={featured} variant="featured" testId="home-featured-article" />
          </Reveal>
        </div>

        <div className="mt-6 grid gap-6 md:grid-cols-3">
          {supporting.map((a, i) => (
            <ArticleCard key={a.slug} article={a} index={i} testId={`home-insight-${i}`} />
          ))}
        </div>
      </div>
    </section>
  );
}
